import {
  PARTNER_LOAD_REQUEST,
  PARTNER_LOAD_SUCCESS,
  PARTNER_LOAD_FAILURE
} from '../types/partner-type';

const initialState = {
  loading: false,
  success: false,
  error: null,
  partner: null
};

function partner(state = initialState, action: any = null) {
  switch (action.type) {
    case PARTNER_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case PARTNER_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case PARTNER_LOAD_SUCCESS:
      return {
        ...state,
        partner: action.payload,
        loading: false,
        success: true,
        error: null
      };

    default:
      return state;
  }
}

export default partner;
